module.exports = __webpack_public_path__ + "img/コンピュータのしくみI_5_5_3.a9519cc0.jpeg";